import axios from 'axios';

import { NutriScoreCategoryBaseIngredientCategory } from 'enums/NutriScoreCategory/NutriScoreCategoryBaseIngredientCategory';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function apiCall(
	nutrientId: string,
	pointType: NutriScoreCategoryBaseIngredientCategory
): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/NutriScoreBaseIngredientCategoryPoints/${nutrientId}`;
	return axios
		.delete(url, {
			params: {
				PointType: pointType,
			},
		})
		.toOptionalVoid();
}
